// Central Sentry config for sign-frontend (CRA).
// The DSN is public by design (shipped in the client bundle) — a literal, not a secret.
export const SENTRY = {
  // Project: sign-frontend. Public by design (shipped in the client bundle) — a literal, not a secret.
  dsn: "https://412a5b10a42d8c56fb797e24a93f524a@o4511741055467520.ingest.us.sentry.io/4511859722944512",
  enabled: process.env.REACT_APP_SENTRY_ENABLED === "true", // dark unless explicitly "true"
  environment: process.env.REACT_APP_ENV || "local",
  release: process.env.REACT_APP_RELEASE || undefined,
};
